import { request } from 'ice';
import { INBOUNDSERVICE, BASEDATASERVICE } from '@/const';
// 获取仓库本地时间（出库）
async function getOutWarehouseTime(data: object) {
  return await request({
    url: `${INBOUNDSERVICE}/outboundBoard/getWarehouseRecentWorkingDayTime`,
    method: 'GET',
    params: data,
  });
}

// 获取仓库本地时间（其他）
// 获取仓库本地时间
async function getWarehouseTime(data: object) {
  return await request({
    url: `${INBOUNDSERVICE}/otaskBoard/getWarehouseCurrentDayTime`,
    method: 'GET',
    params: data,
  });
}

// 获取首页文章弹窗
async function getPopupArticles(data: object) {
  return await request({
    url: `/giws-basic/system/articleReadRecord/getPopupArticle`,
    method: 'GET',
    params: data,
  });
}

// 点击不在提醒 /system/articleReadRecord/dontRemind
async function setdontmind(data: object) {
  return await request({
    url: `/giws-basic/system/articleReadRecord/dontRemind?articleId=${data}`,
    method: 'GET',
  });
}

async function getpeople(tid) {
  return await request.get(`${BASEDATASERVICE}/system/articleReadRecord/getReadPeopleCount?articleId=${tid}`);
}

async function getcount(tid) {
  return await request.get(`${BASEDATASERVICE}/system/articleReadRecord/getReadTotalCount?articleId=${tid}`);
}

export { getWarehouseTime, getOutWarehouseTime, getPopupArticles, setdontmind, getpeople, getcount };
